import React from 'react';
import { Platform } from 'react-native';
import { t } from '@lingui/macro';
import { createDrawerNavigator } from '@react-navigation/drawer';
import styled from 'styled-components';

import FontIcon from '@src/components/FontIcon';
import Image from '@src/components/Image';
import useActiveOnRegions from '@src/hooks/useActiveOnRegions';
import { i18n } from '@src/i18n';
import AddLocationScreen from '@src/screens/Dummy';

import Dashboard from './Dashboard';
import DrawerContent from './DrawerContent';
import DummyDashboardStack from './DummyDashboardStack';
import HeroesStack from './HeroesStack';
import { DrawerParamList } from './types';
import WalletStack from './WalletStack';

const Icon = styled(Image)`
  width: 24px;
  height: 24px;
  resize-mode: contain;
`;

const Drawer = createDrawerNavigator<DrawerParamList>();

const Component: React.FC = () => {
  const regions = useActiveOnRegions('IR');

  return (
    <Drawer.Navigator
      drawerType={Platform.OS === 'web' ? 'front' : 'slide'}
      screenOptions={{ unmountOnBlur: true }}
      backBehavior="none"
      drawerContent={(props) => <DrawerContent {...props} />}
    >
      <Drawer.Screen
        name="Dashboard"
        options={{
          title: i18n._(t`Dashboard`),
          drawerIcon: (props) => <FontIcon name="columns" {...props} />,
        }}
        component={regions ? Dashboard : DummyDashboardStack}
      />
      <Drawer.Screen
        name="WalletStack"
        options={{
          title: i18n._(t`Wallet`),
          drawerIcon: (props) => (
            <Icon source={require('@src/assets/images/profile.png')} />
          ),
        }}
        component={WalletStack}
      />
      <Drawer.Screen
        name="AddLocation"
        options={{
          title: i18n._(t`Register new location`),
          drawerIcon: (props) => <FontIcon name="map-marker-alt" {...props} />,
        }}
        component={AddLocationScreen}
      />
      <Drawer.Screen
        name="HeroesStack"
        options={{
          title: i18n._(t`Heroes`),
          drawerIcon: (props) => <FontIcon name="medal" {...props} />,
        }}
        component={HeroesStack}
      />
    </Drawer.Navigator>
  );
};

Component.displayName = 'Drawer';

export default Component;
